import { createAction } from '@reduxjs/toolkit';

/**
 * Actions
 */
export const deepTagReportFileUploadModalContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>(
    'DeepTagReportFileUploadModalContainer/navigateTo'
  ),
};
